const resolveImgUrl = (imgPath, language) => {
  const baseLang = language.split('-')[0];
  const imgUrl = `/images/${baseLang}/${imgPath}`;
  return imgPath ? imgUrl : imgPath;
};

export default resolveImgUrl;
